export enum StandardObjectKey {
  TASK = "task",
  CONTACT = "contact",
  BUSINESS = "business",
  OPPORTUNITY = "opportunity"
}

export const DefaultStandardObjectLabels = {
  [StandardObjectKey.CONTACT]: {
    singular: 'Contact',
    plural: 'Contacts'
  },
  [StandardObjectKey.BUSINESS]: {
    singular: 'Company',
    plural: 'Companies'
  },
  [StandardObjectKey.OPPORTUNITY]: {
    singular: 'Opportunity',
    plural: 'Opportunities'
  }
}
